const FeatureItem = ({
  description,
  title,
}: {
  title: string
  description: string
}) => {
  return (
    <div className='d-flex flex-column gap-3 lh-114'>
      <span className='fw-bold'>{title}</span>
      <span className='color-grey5 fw-semibold'>{description}</span>
    </div>
  )
}
export default FeatureItem
